import { Box, Paper, Typography } from '@mui/material';
import { useDraggable } from '@dnd-kit/core';
import { ELEMENT_TYPE_LABELS, PALETTE_ELEMENT_TYPES } from './editorUtils';
import { ELEMENT_TYPE_ICONS } from './elementIcons';

const PaletteTile = ({ type, onAdd, disabled }) => {
  const Icon = ELEMENT_TYPE_ICONS[type];
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `palette-${type}`,
    data: { from: 'palette', elementType: type, label: ELEMENT_TYPE_LABELS[type] },
    disabled,
  });

  return (
    <Paper
      ref={setNodeRef}
      variant='outlined'
      onClick={() => !disabled && onAdd(type)}
      {...attributes}
      {...listeners}
      sx={{
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.5,
        cursor: disabled ? 'default' : 'grab',
        opacity: isDragging ? 0.4 : 1,
        userSelect: 'none',
        touchAction: 'none',
        '&:hover': disabled ? undefined : { borderColor: 'primary.main', backgroundColor: 'action.hover' },
      }}
    >
      <Icon fontSize='small' color='action' />
      <Typography variant='caption' align='center'>
        {ELEMENT_TYPE_LABELS[type]}
      </Typography>
    </Paper>
  );
};

// "Grundelemente" tab: draggable tiles for the basic e-mail building blocks.
// Tiles can be dragged into the canvas or clicked to append at the end.
const ElementPalette = ({ onAdd, disabled }) => (
  <Box sx={{ p: 2 }}>
    <Typography variant='body2' color='text.secondary' sx={{ mb: 1.5 }}>
      Ziehen Sie ein Element in die E-Mail oder klicken Sie darauf, um es am Ende einzufügen.
    </Typography>
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
      {PALETTE_ELEMENT_TYPES.map(type => (
        <PaletteTile key={type} type={type} onAdd={onAdd} disabled={disabled} />
      ))}
    </Box>
  </Box>
);

export default ElementPalette;
